
import { supabase } from '@/integrations/supabase/client'
import { logger } from './logger-service'

export class FeatureService {
  public static async trackFeatureUsage(featureName: string, userId: string): Promise<void> {
    try {
      // First try to get existing metric
      const { data: existingMetric, error: fetchError } = await supabase
        .from('feature_metrics')
        .select('*')
        .eq('feature_name', featureName)
        .eq('user_id', userId)
        .maybeSingle();

      if (fetchError) {
        throw fetchError;
      }

      if (existingMetric) {
        // Update existing metric
        const { error: updateError } = await supabase
          .from('feature_metrics')
          .update({
            usage_count: existingMetric.usage_count + 1,
            last_used: new Date().toISOString()
          })
          .eq('id', existingMetric.id);

        if (updateError) {
          throw updateError;
        }
      } else {
        // Create new metric
        const { error: insertError } = await supabase
          .from('feature_metrics')
          .insert({
            feature_name: featureName,
            user_id: userId,
            usage_count: 1,
            last_used: new Date().toISOString()
          });

        if (insertError) {
          throw insertError;
        }
      }

      logger.info('Feature usage tracked successfully', {
        featureName,
        userId
      });
    } catch (error) {
      logger.error('Error tracking feature usage', {
        error,
        featureName,
        userId
      });
      // We don't want to throw the error as feature tracking should not break the app
      // Just log it and continue
    }
  }
}
